import { render, staticRenderFns } from "./MercalaButton.vue?vue&type=template&id=57d43f23"
import script from "./MercalaButton.vue?vue&type=script&lang=js"
export * from "./MercalaButton.vue?vue&type=script&lang=js"
import style0 from "./MercalaButton.vue?vue&type=style&index=0&id=57d43f23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports